// frontend/src/pages/ChatPage.js
import React from 'react';
import ChatIA from '../components/ChatIA';
import PageHeader from '../components/ui/PageHeader';
import '../style/pages/ChatPage.css';

const ChatPage = () => {
    // Por ahora usamos un usuarioId fijo, pero deberías obtenerlo del contexto de autenticación
    const usuarioId = 1;

    return (
        <div className="chat-page-container area-herramientas">
            <PageHeader
                variante="banner"
                icono="robot"
                titulo="Themis IA"
                descripcion="Pregunta lo que necesites sobre clientes, trámites y eventos"
            />
            <div className="chat-page-content">
                <ChatIA usuarioId={usuarioId} />
            </div>
        </div>
    );
};

export default ChatPage;

